module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Light.fc6f1f35.woff";